/**
 * Defines the mutations for the unsavedChangesGuard module.
 */

import { MutationTree } from 'vuex';
import { UnsavedChangesGuardState } from './types/unsavedChangesGuard.types';

const mutations: MutationTree<UnsavedChangesGuardState> = {
  /**
   * Sets the global modal active flag.
   * @param {UnsavedChangesGuardState} state - The current state of the module
   * @param {boolean} isActive - The new value for the isModalActive flag. True if a modal is active, false otherwise
   */
  SET_MODAL_ACTIVE(state: UnsavedChangesGuardState, isActive: boolean): void {
    // Directly update the state property
    state.isModalActive = isActive;
    // If modal is no longer active, reset the keep editing flag
    if (!isActive) {
      state.userSelectedKeepEditing = false;
    }
  },

  /**
   * Sets the flag indicating the user chose to keep editing.
   * @param {UnsavedChangesGuardState} state - The current state of the module.
   * @param {boolean} keepEditing - True if user selected "Keep Editing", false to reset.
   */
  SET_USER_SELECTED_KEEP_EDITING(
    state: UnsavedChangesGuardState,
    keepEditing: boolean,
  ): void {
    state.userSelectedKeepEditing = keepEditing;
  },

  /**
   * Sets the active state of the "Discard Unsaved Changes?" dialog.
   * @param {UnsavedChangesGuardState} state - The current state of the module.
   * @param {boolean} isActive - True if the dialog is active, false otherwise.
   */
  SET_UNSAVED_CHANGES_DIALOG_ACTIVE(
    state: UnsavedChangesGuardState,
    isActive: boolean,
  ): void {
    state.isUnsavedChangesDialogActive = isActive;
  },
};

export default mutations;
